<template>
  <div class="user-header">
      <button @click="back" type="button" class="button primary block">
        <svg width="42px" height="42px" viewBox="0 0 42 42" xml:space="preserve"> <polygon fill-rule="evenodd" points="27.066,1 7,21.068 26.568,40.637 31.502,35.704 16.865,21.068 32,5.933 "/> </svg>
        Geri Dön</button>
      <div>
        <p><b>Min: {{ min }}  {{ user.currency }}</b> &nbsp; <b>Maks: {{ max }}  {{ user.currency }}</b></p>
        <h3 class="line-title" :class="'pay_' + $route.params.payment">{{ name }} </h3>
      </div>
  </div>
</template>

<script>
  export default{
    props:['name','min','max'],
    methods:{
      back(){
          this.$parent.$parent.provider = null;
          this.$parent.$parent.home = true;
          if(this.$route.params.section){
            this.$router.replace({ name: 'User', params: { section: this.$route.params.section, payment: null } })
          }
      },
    },
    computed:{
      user(){
        return this.$user();
      }
    }
  }
</script>